<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="LBLBASEINFO" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn
                  v-if="isOld && !disabled && editable"
                  label="LBLREMOVE"
                  icon="remove"
                  @btnClicked="deleteData"/>
                <c-btn
                  v-if="!disabled && isOld && editable"
                  :url="completeUrl"
                  :isSubmit="isComplete"
                  :param="measData"
                  mappingType="PUT"
                  label="LBLCOMPLETE"
                  icon="check"
                  @beforeAction="completeData"
                  @btnCallback="completeCallback" />
                <c-btn
                  v-if="!disabled && editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="measData"
                  :mappingType="mappingType"
                  label="저장"
                  icon="save"
                  @beforeAction="saveData"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <c-text
                  required
                  :editable="editable"
                  :disabled="disabled"
                  label="측정기관"
                  name="measPlaceName"
                  v-model="measData.measPlaceName">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-datepicker
                  required
                  :editable="editable"
                  type="year"
                  :disabled="disabled"
                  label="측정년도"
                  name="measYear"
                  v-model="measData.measYear">
                </c-datepicker>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <!-- 분기 -->
                <c-select
                  required
                  type="edit"
                  :editable="editable"
                  codeGroupCd="WORK_MEAS_QUARTER_CD"
                  itemText="codeName"
                  :disabled="disabled"
                  itemValue="code"
                  name="measQuarter"
                  label="분기"
                  v-model="measData.measQuarter"
                ></c-select>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-datepicker
                  :editable="editable"
                  type="date"
                  :disabled="disabled"
                  label="측정기간"
                  :range="true"
                  name="measPeriod"
                  v-model="measPeriod">
                </c-datepicker>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-plant
                  required
                  :editable="editable"
                  :disabled="disabled"
                  type="edit"
                  name="plantCd"
                  v-model="measData.plantCd">
                </c-plant>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <c-text
                  required
                  :editable="editable"
                  :disabled="disabled"
                  label="측정계획명"
                  name="measPlanContent"
                  v-model="measData.measPlanContent">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-text
                  suffix="℃"
                  :editable="editable"
                  :disabled="disabled"
                  label="작업장기온"
                  name="measTemperature"
                  v-model="measData.measTemperature">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-text
                  suffix="%"
                  :editable="editable"
                  :disabled="disabled"
                  label="작업장습도"
                  name="measHumidity"
                  v-model="measData.measHumidity">
                </c-text>
              </div>
              <!-- <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <c-hea-checkup
                  :editable="editable"
                  :disabled="disabled"
                  checkupTypeCd="CUTC000002"
                  name="heaCheckupPlanId"
                  v-model="measData.heaCheckupPlanId">
                </c-hea-checkup>
              </div> -->
            </template>
          </c-card>
        </div>
      </div>
    </q-form>
    <c-tab
      class="q-mt-sm"
      type="tabcard"
      align="left"
      :tabItems.sync="tabItems"
      :height="tabHeight"
      :inlineLabel="true"
      v-model="tab"
    >
      <template v-slot:default="tab" >
        <component
          :is="tab.component"
          :measData.sync="measData"
          :contentHeight="contentHeight"
          :disabled.sync="disabled"
          :isOld.sync="isOld"
          @getDetail="getDetail"
        />
      </template>
    </c-tab>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'work-measure-plan-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        workMeasurementPlanId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      mappingType: 'POST',
      saveUrl: '',
      insertUrl: '',
      updateUrl: '',
      completeUrl: '',
      deleteUrl: '',
      checkUrl: '',
      editable: true,
      isSave: false,
      isComplete: false,
      measData: {
        workMeasurementPlanId: '',
        plantCd: '',
        measPlaceName: '',
        measPlanContent: '',
        measQuarter: null,
        measYear: '',
        measStartDate: '',
        measEndDate: '',
        measCompleteFlag: 'N',
        measTemperature: '',
        measHumidity: '',
        heaCheckupPlanId: '',
        noiseList: [],
        notNoiseList: [],
        noiseImprList: [],
        notNoiseImprList: [],

        updateFlag: '',
        regUserId: '',
        chgUserId: '',
      },
      measPeriod: ['', ''],
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      measTime: [],
      tab: 'notNoise',
      tabItems: [
        { name: 'notNoise', icon: 'groups', label: '소음제외', component: () => import(`${'./workMeasureNotNoise.vue'}`) },
        { name: 'noise', icon: 'groups', label: '소음', component: () => import(`${'./workMeasureNoise.vue'}`) },
        { name: 'resultImpr', icon: 'health_and_safety', label: '개선목록', component: () => import(`${'./workMeasureResultImpr.vue'}`) },
      ],
    };
  },
  computed: {
    disabled() {
      return this.editable && false
    },
    isOld() {
      return Boolean(this.popupParam.workMeasurementPlanId)
    },
    tabHeight() {
      return String(this.contentHeight - 240);
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sai.workmeas.plan.get.url;
      this.checkUrl = selectConfig.sai.workmeas.plan.check.url;
      this.saveUrl = transactionConfig.sai.workmeas.plan.insert.url;
      this.insertUrl = transactionConfig.sai.workmeas.plan.insert.url;
      this.updateUrl = transactionConfig.sai.workmeas.plan.update.url;
      this.deleteUrl = transactionConfig.sai.workmeas.plan.delete.url;
      this.completeUrl = transactionConfig.sai.workmeas.plan.complete.url;
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.workMeasurementPlanId) {
        this.$http.url = this.$format(this.detailUrl, this.popupParam.workMeasurementPlanId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.measData = _result.data;
          if (_result.data.measStartDate && _result.data.measEndDate) {
            this.measPeriod = [this.measData.measStartDate, this.measData.measEndDate];
          }
          // 상세팝업 최초작성/최근수정 정보 노출
          this.$emit('setRegInfo', _result.data)
        },);
      } else {
        this.measData.measYear = this.$comm.getThisYear();
        if (parseInt(this.$comm.getThisMonth().substring(5,8)) < 7) {
          this.measData.measQuarter = 'WMQ0000001'; // 상반기
        } else {
          this.measData.measQuarter = 'WMQ0000002'; // 하반기
        }
      }
    },
    saveData() {
      if (this.popupParam.workMeasurementPlanId) {
        this.saveUrl = this.updateUrl;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.mappingType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          this.$http.url = this.$format(this.checkUrl, this.measData.measYear, this.measData.measQuarter, this.measData.plantCd);
          this.$http.type = 'GET';
          this.$http.request((_result) => {
            if (this.isOld || _result.data === 0) {
              window.getApp.$emit('CONFIRM', {
                title: 'LBLCONFIRM',
                message: 'MSGSAVE', // 저장하시겠습니까?
                // TODO : 필요시 추가하세요.
                type: 'info', // success / info / warning / error
                // 확인 callback 함수
                confirmCallback: () => {
                  this.measData.regUserId = this.$store.getters.user.userId;
                  this.measData.chgUserId = this.$store.getters.user.userId;

                  if(this.measPeriod) {
                    this.measData.measStartDate = this.measPeriod[0];
                    this.measData.measEndDate = this.measPeriod[1];
                  }
                  this.isSave = !this.isSave;
                },
                // 취소 callback 함수
                cancelCallback: () => {
                },
              });
            } else {
              window.getApp.$emit('ALERT', {
                title: 'LBLGUIDE', // 안내
                message:
                '동일한 년도(분기)가 존재합니다.',
                type: 'warning', // success / info / warning / error
              });
              return;
            }
          },);
          
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    deleteData() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: 'MSGREMOVE', // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.workMeasurementPlanId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.workMeasurementPlanId = result.data
      this.getDetail();
    },
    completeData() {
      if (this.measData.noiseList.length > 0 && this.measData.notNoiseList.length > 0) {
        this.$refs['editForm'].validate().then(_result => {
          if (_result) {
            window.getApp.$emit('CONFIRM', {
              title: 'LBLCONFIRM',
              message: 'MSGCOMPLETE', // 완료하시겠습니까?,
              // TODO : 필요시 추가하세요.
              type: 'info', // success / info / warning / error
              // 확인 callback 함수
              confirmCallback: () => {
                this.measData.regUserId = this.$store.getters.user.userId;
                this.measData.chgUserId = this.$store.getters.user.userId;

                if(this.measPeriod) {
                  this.measData.measStartDate = this.measPeriod[0];
                  this.measData.measEndDate = this.measPeriod[1];
                }
                this.isComplete = !this.isComplete;
              },
              // 취소 callback 함수
              cancelCallback: () => {
              },
            });
          } else {
            window.getApp.$emit('APP_VALID_ERROR');
          }
        });
      } else {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message:
          '등록된 작업환경 측정결과가 없습니다.',
          type: 'warning', // success / info / warning / error
        });
      }
    },
    completeCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.workMeasurementPlanId = result.data
      this.getDetail();
    },
  }
};
</script>
